import { Directive, Input, OnInit, OnChanges, SimpleChanges, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appPatientValidationStatus]',
  exportAs: 'appPatientValidationStatus'
})
export class PatientValidationStatusDirective implements OnInit, OnChanges {
  @Input('appPatientValidationStatus') patient: any;

  // Expose flags for the template
  showIncompleteFile = false;
  showICDValidation = false;
  showSelfBoarded = false;
  showInviteStatus = false;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    this.updateFlags();
    this.updateClasses();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['patient']) {
      this.updateFlags();
      this.updateClasses();
    }
  }

  get hasErrors() {
    return this.showIncompleteFile || this.showICDValidation || this.showSelfBoarded || this.showInviteStatus;
  }

  private updateFlags() {
    this.showIncompleteFile = !!this.patient?.requiresValidation;
    this.showICDValidation = !!this.patient?.requiresICDValidation;
    this.showSelfBoarded = !!this.patient?.wasSelfBoarded;
    this.showInviteStatus = this.patient?.status === 'invite';
  }

  private updateClasses() {
    if (this.hasErrors) {
      this.renderer.addClass(this.el.nativeElement, 'requires-validation');
    } else {
      this.renderer.removeClass(this.el.nativeElement, 'requires-validation');
    }
  }
} 